if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.elements = {
          inputCountry: this.querySelector('input[name="country_code"]'),
          inputLanguage: this.querySelector('input[name="locale_code"]'),
        };
        this.details = document.querySelector('[data-drawer="country-selector"]');
      }

      connectedCallback() {
        this.querySelectorAll('input[type="radio"]').forEach(input => {
          input.addEventListener('click', (event) => {
            if (input.checked) {
              this.elements.inputCountry.value = input.dataset.country;
              this.elements.inputLanguage.value = input.dataset.language;
              this.form.submit();
            }
          });
        });
        this.closeMenuDrawer(this.details);
      }
      
      closeMenuDrawer(details) {
        const closeButtons = this.querySelectorAll('[data-close-details], .country-localization-button');
        closeButtons.forEach((button) => {
            button.addEventListener('click', () => {
                if (details) {
                    details.removeAttribute('open');
                }
            });
        });
      }
    }
  );
}
